import React from "react";
import ReactDOM from "react-dom";
import paypal from "paypal-checkout";
import firebaseManager from "../../../model/Firebase/FirebaseManager";

const PaypalCheckOutButton = ({ order }) => {
  const paypalConf = {
    currency: "USD",
    env: "sandbox",
    client: {
      sandbox:
        "ASzfFOi-mofltuPvlIOQP1YOxJvuvccERi7mztaNdZcJWOe1hnT5IxNk3LrJhbBsD0TtAAb67vx9ujLl",
      production: "",
    },
    style: {
      label: "pay",
      size: "medium",
      shape: "rect",
      color: "gold",
    },
  };

  const PayPalButton = paypal.Button.driver("react", { React, ReactDOM });

  const payment = (data, actions) => {
    const payment = {
      transactions: [
        {
          amount: {
            total: order,
            currency: paypalConf.currency,
          },
          description: "Pay the service",
        },
      ],
      note_to_payer: "Thanks for your pay",
    };
    return actions.payment.create({ payment });
  };

  const onAuthorize = (data, actions) => {
    return actions.payment
      .execute()
      .then((response) => {
        firebaseManager.confirmPaymentDent();
      })
      .catch((error) => {
        console.log(error);
        sessionStorage.setItem("paymentFail", false);
        alert("Fail to pay");
      });
  };

  const onError = (error) => {
    console.log(error);
    alert("The pay is not succesly, please again");
  };

  const onCancel = (data, actions) => {
    alert("Pay canceled");
  };

  return (
    <PayPalButton
      env={paypalConf.env}
      client={paypalConf.client}
      payment={(data, actions) => payment(data, actions)}
      onAuthorize={(data, actions) => onAuthorize(data, actions)}
      onCancel={(data, actions) => onCancel(data, actions)}
      onError={(error) => onError(error)}
      style={paypalConf.style}
    />
  );
};

export default PaypalCheckOutButton;
